import React from 'react'
import vg from "../assets/2.png"
import {AiFillGoogleCircle, AiFillAmazonCircle, AiFillYoutube, AiFillInstagram} from "react-icons/ai"

const Home = () => {
  return (
    <>
    <div className="home" id="home">
        <main>
            <h1>Kabir Tech Serv</h1>
            <p>Solution to all your technical problems</p>
        </main>
    </div>
    <div className="home2">
        <img src={vg} alt="Graphic" />
        <div>
        <p>
        At Kabir Tech Sol, we harness the power of technology to provide cutting-edge solutions tailored to your business needs. From software development to digital transformation strategies, our expertise is dedicated to helping your business thrive in a digital world.
        </p>
        </div>
    </div>
    <div className="home3" id="about">
        <div>
        <h1>Who We Are?</h1>
        <p>
        Welcome to the digital frontier! At Kabir Tech Sol, we are pioneers in the tech landscape, where innovation meets practicality. From the silicon-inspired valleys of creativity to the summit of binary brilliance, our journey is fueled by a passion for transforming challenges into technological triumphs.
        Navigating through the algorithms of success, our team of visionary coders and strategists architect solutions that not only compute but also connect. We believe in the power of code to change the world, crafting systems that are not only efficient but also intuitive.
        Each pixel, each line of code is infused with excellence. Our digital artisans blend aesthetic precision with technological acumen to deliver bespoke solutions. Whether it’s enhancing cybersecurity or streamlining cloud operations, our expertise is your competitive edge.
        In the realm of connectivity, we are the bridge builders. Our solutions ensure seamless integration and flawless functionality, empowering your business to operate at global standards. From startups to stalwarts, our technology speaks the universal language of growth and innovation.
        At the core of our mission lies a commitment to ethical innovation. We navigate the complex matrix of technology with integrity, ensuring that our advancements benefit society as a whole. Join us as we continue to explore, invent, and inspire.
        At Kabir Tech Sol, your vision is our blueprint. Let us help you build the future. Because here, we don’t just think about the next step; we imagine the next leap.
        </p>
        </div>
    </div>
    <div className="home4" id="brands">
        <div>
            <h1>Brands</h1>
            <article>
                <div style={{animationDelay: "0.3s",}}>
                    <AiFillGoogleCircle/>
                    <p>Google</p>
                </div>
                <div style={{animationDelay: "0.5s",}}>
                    <AiFillAmazonCircle/>
                    <p>Amazon</p>
                </div>
                <div style={{animationDelay: "0.7s",}}>
                    <AiFillYoutube/>
                    <p>Youtube</p>
                </div>
                <div style={{animationDelay: "1s",}}>
                    <AiFillInstagram/>
                    <p>Instagram</p>
                </div>
            </article>
        </div>
    </div>
    </>
  )
}

export default Home